import { ReactNode } from 'react'

interface MinimalLayoutProps {
  children: ReactNode
}

export const MinimalLayout = ({ children }: MinimalLayoutProps) => {
  return <div className="h-full w-full">{children}</div>
}
